module.exports = __webpack_public_path__ + "static/media/PM85.b8e8275c.png";